import { STEP_PROGRESS_MOVEMENT, allStepsArray } from './constants';

export const getAge = (DOB: any) : number => {
  const today = new Date();
  const birthDate = new Date(DOB);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const getNumberSuffix = (num: number) : string => {
  const rem = num % 10;
  if (rem === 1) {
    return 'st';
  } if (rem === 2) {
    return 'nd';
  } if (rem === 3) {
    return 'rd';
  }
  return 'th';
};

export const allowOnlyNumber = (val: string) => {
  // eslint-disable-next-line prefer-regex-literals
  const reg = new RegExp('^[0-9]+$');
  return reg.test(val) || !val;
};

export const DEBOUNCE_TIME = 500;

export const debounce = (func: any, wait: number, immediate: boolean) => {
  let timeout: any;
  // eslint-disable-next-line func-names
  return function (...args: any) {
    // @ts-expect-error
    const context = this;
    const later = () => {
      timeout = null;
      func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

export const getProgressStepper = (step:string) => {
  if (step === "modification") {
    return 10.5 * STEP_PROGRESS_MOVEMENT;
  }
  const progress = allStepsArray.findIndex((element) => element === step) + 1;
  return progress * STEP_PROGRESS_MOVEMENT;
};

export const getToken = () => localStorage.getItem('token') || null

function isObject(val: any): any {
  return typeof val === 'object' && val !== null;
}

export const deepClone = <T>(source: T): T => {
  // If the source isn't an Object or Array, throw an error.
  if (!isObject(source) || source instanceof Date || source instanceof String) {
    return source;
  }

  // Set the target data type before copying.
  const target = (source instanceof Array ? [] : {}) as T;

  // eslint-disable-next-line no-restricted-syntax
  for (const prop in source) {
    // Make sure the property isn't on the prototype
    if (!Object.prototype.hasOwnProperty.call(source, prop)) {
      // eslint-disable-next-line no-continue
      continue
    }

    // If the current property is an Array or Object, recursively clone it, else copy its value
    if (isObject(source[prop]) && !(source[prop] instanceof Date) && !(source[prop] instanceof String)) {
      // @ts-ignore
      target[prop] = deepClone(source[prop]) as T[Extract<keyof T, string>];
    } else {
      // @ts-ignore
      target[prop] = source[prop] as T[Extract<keyof T, string>];
    }
  }

  return target;
};

export const isEighteenYearsOld = (birthDate: Date | string): boolean => {
  if (!birthDate) {
    return false;
  }

  const today = new Date();
  const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

  return birthDate <= eighteenYearsAgo;
};

export function convertString(str:string) {
  let words = str.split(/(?=[A-Z])/);
  // eslint-disable-next-line max-len
  words = words.map((word, index) => (index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word.charAt(0).toLowerCase() + word.slice(1)));
  return words.join(' ');
}
